import React from 'react';

export default ({ header, children, ...props }) => <div className='zt-form__block'>
    { header &&
    <h4 className='zt-form__block__label light'>{header}</h4>
    }
    {children}
</div>